import { useTranslation } from 'react-i18next'

import { Flex } from '@chakra-ui/react'

import { ReasonType } from '@wwt/entities/reason'
import { Offer } from '@wwt/entities/search-response'

import { useUndislikeMutation } from '@/entities/likeDislike'
import { useBreakpointValueWithoutSSR } from '@/shared/lib/hooks/useBreakpointValueWithoutSSR'

import { QuickActionMiniSection } from './QuickActionMiniSection'
import { ReasonPopupHeader } from './ReasonPopupHeader'

interface DislikeContentProps {
	offer: Offer
	onOpenInfo: () => void
	onOpenReview: () => void
	onDislikeCancel?: () => void
	onClose: () => void
	isFixed: boolean
	type: ReasonType
	offerId: string
}

export const DislikeContent = ({
	offer,
	onOpenInfo,
	onOpenReview,
	onDislikeCancel,
	onClose,
	isFixed,
	type,
	offerId
}: DislikeContentProps) => {
	const { t } = useTranslation('tooltips')
	const undislike = useUndislikeMutation()

	const handleCancelDislike = () => {
		undislike.mutate(offer)

		onClose()
		onDislikeCancel?.()
	}

	const title = useBreakpointValueWithoutSSR({
		base: t('reasonPopup.undislike'),
		md: t('reasonPopup.cancelDislike')
	})

	return (
		<Flex
			w="100%"
			flexDirection={{ base: 'row', md: 'column' }}
			alignItems={{ base: 'center', md: 'unset' }}
		>
			<ReasonPopupHeader
				isFixed={isFixed}
				headerText={title ?? ''}
				onClick={handleCancelDislike}
				textStyle="body-text-6"
				onClose={onClose}
			/>
			<QuickActionMiniSection
				onInfoPopupOpen={onOpenInfo}
				onReviewPopupOpen={onOpenReview}
				onClose={onClose}
				offerId={offerId}
				type={type}
			/>
		</Flex>
	)
}
